import React from "react";
import Typography from "@material-ui/core/Typography";

const labelStyle = {
  textAlign: "left",
  marginBottom: 4
};

const Label = ({ children, ...rest }) => {
  return (
    <Typography variant="body1" style={labelStyle}>
      {children}
    </Typography>
  );
};

export default Label;
